import React, { useState, useEffect } from 'react';
import { useSnackbar } from "notistack";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Autocomplete, CircularProgress, Box, Link, Tooltip, Typography } from '@mui/material';
import { AttachementsUpload } from '../../../../shared_elements/components';
import { addIndConditionAPi, updateIndConditionAPi, clauseAPi } from '../apiService';
import { globalPostService, globalPutService, globalGetService } from '../../../../utils/globalApiServices';
import { checkApiStatus } from '../../../../utils';
import { PageLoader } from '../../../../shared_elements';
import { trackActivity } from '../../../../utils/mixpanel';
import { setFileUploadDetails } from '../../../../shared_elements/actions';
import { useDispatch, useSelector } from 'react-redux';
import { formatBytes } from '../../../../utils/fileUpload';
import { regexConstants } from '../../../../constants/regEx';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';

const InductionConditionCRU = ({ inductionConditionCRU, fileUpload, modeType, getResponseBack, onOpenAttachments, onToggleModal }) => {
    const dispatch = useDispatch()
    const navigate=useNavigate();
    const { leaseSlug } = useParams();
    const { storageDetails } = useSelector((state) => state.leases);
    const params = { leaseSlug: leaseSlug };
    const [error, setError] = useState({});
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState(inductionConditionCRU?.data);
    const { enqueueSnackbar } = useSnackbar()
    const [attachments, setAttachments] = useState([]);
    const [clauseapi, setClauseAPi] = useState([])
    const [dropDownLoader, setDropDownLoader] = useState(false)

    useEffect(() => {
        conditionClauseApi()
    }, [])
    const handleFileChange = (files) => {
        setAttachments(files);
        dispatch(setFileUploadDetails({ attachments: files }))
    };

    const onFieldChange = (key, value) => {
        setData({ ...data, [key]: value });
        setError((prev) => ({ ...prev, [key]: '' }));
    };
    const conditionClauseApi = () => {
        setDropDownLoader(true);
        globalGetService(clauseAPi(params))
            .then(response => {
                if (checkApiStatus(response)) {
                    let responseClause = [];
                    const data = response?.data.data?.list;
                    data?.map((item) => {
                        responseClause.push({ id: item?.id, name: item?.name })
                    });
                    setClauseAPi(responseClause || []);
                }
                setDropDownLoader(false)
            })
    }
    const onAddEditMember = () => {
        let validationInputs = {};
        validationInputs = {
            asset_conditions_for_contract_id: data?.asset_conditions_for_contract_id ? "" : "Please select Clause",
            terms: data?.terms?.trim() ? "" : "Please enter Terms",
        };
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            if (data.id) {
                globalPutService(updateIndConditionAPi({ ...params, slug: data?.slug }), data).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(data?.slug,'updated')
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Edited', { page_title: `Edit Induction Condition`, success_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Edited', { page_title: `Edit Induction Condition`, error_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    }
                });
            } else {
                globalPostService(addIndConditionAPi(params), data).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(response?.data?.data?.slug,'created')
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Added', { page_title: `Add Induction Condition`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Induction Condition`, error_msg: response?.data?.message, item_id: null, payload: data, response: response?.data })
                    }
                });
            }
        } else {
            setError(validationInputs);
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Induction Condition`, error_msg: validationInputs, })
        }
    };

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Induction Condition`, page_type: page_type, })
    }
    return (
        <>
            <Dialog
                // onClose={onToggleModal}
                aria-labelledby="customized-dialog-title"
                className='add-lease-dialog'
                maxWidth='md'
                fullWidth
                open={true}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                    <Typography sx={{ marginLeft: '10px' }}>
                        {modeType === 'add' ? 'Add Induction Condition' : modeType === 'edit' ? 'Edit Induction Condition' : 'View Induction Condition'}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                options={clauseapi || []}
                                disabled={modeType === 'view'}
                                getOptionLabel={(option) => option?.name || ""}
                                noOptionsText={modeType !== "view" && dropDownLoader?.asset_conditions_for_contract_id ? "Loading..." : <Link onClick={() => navigate(`/settings/clause`)} sx={{ textDecoration: "none", cursor: "pointer" }} >+ Add New Clause</Link>}
                                value={data?.asset_conditions_for_contract_id || null}
                                onChange={(e, value) => { onFieldChange("asset_conditions_for_contract_id", value) }}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow>
                                            <TextField
                                                required
                                                {...params}
                                                label="Clause"
                                                margin='normal'
                                                size='small'
                                                error={error.asset_conditions_for_contract_id || false}
                                                helperText={error.asset_conditions_for_contract_id || ''}
                                                slotProps={{
                                                    inputLabel: { shrink: true, }, input: {
                                                        ...params?.InputProps, endAdornment: (<>{dropDownLoader && modeType !== "view" && (
                                                            <CircularProgress color="inherit" size={20} />
                                                        )}
                                                            {params?.InputProps?.endAdornment}</>)
                                                    }
                                                }}
                                                disabled={modeType === 'view'}
                                            />
                                        </Tooltip>)
                                }}
                            />
                        </Grid>
                        {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Terms' required={true} value={data?.terms || ""} />
                        </Grid> :
                            <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    required
                                    id="terms"
                                    label="Terms"
                                    variant="outlined"
                                    size='small'
                                    margin='normal'
                                    multiline
                                    rows={2}
                                    error={!!error.terms}
                                    helperText={error.terms}
                                    value={data?.terms || ''}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("terms", e.target.value.trimStart()) : e.preventDefault()
                                    }}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    fullWidth
                                    disabled={modeType === 'view'}
                                />
                            </Grid>}
                        {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Remarks' value={data?.remarks || ""} />
                        </Grid> :
                            <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    id="remarks"
                                    label="Remarks"
                                    variant="outlined"
                                    size='small'
                                    margin='normal'
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    value={data?.remarks || ''}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("remarks", e.target.value.trimStart()) : e.preventDefault()
                                    }}
                                    disabled={modeType === 'view'}
                                />
                            </Grid>}
                        <Grid size={{ md: 12, xs: 12 }} sx={{mt: 3}}>
                           <Box className="responsive-buttons">
                            {data?.id && data?.attachments?.length ?
                                <Button onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({data?.attachments?.length})Attachment(s)</Button> : null
                            }
                             <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                                          </Box>
                            {modeType === 'view' ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={data?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className='cancel-btn' disabled={isLoading} variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null :
                    <Button variant='contained' size='small' className='btn-primary' onClick={() => { handleItemClicked('Save Button'); onAddEditMember() }}>{isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
        </>

    )
}
export default InductionConditionCRU